import { useState, useEffect } from 'react'
import parse from "html-react-parser"
import Map from "../Page/Map"
import Gallery from "../Page/Gallery"
import Image from "../Page/Image"
import Center from "../App/Center"
import BookingCalendar from "../Cruise/BookingCalendar"

export default function Row( props ) {

	//console.log( props )

	return <Center>
		<div className={ "two" + ( props.right ? " right" : " left" ) }>
            <div 
            	className="half-text"
            	style={{ 
            		display:props.template === 'cruiseIntro' && 'flex', 
            		justifyContent:props.template === 'cruiseIntro' && 'center', 
            	}}
        	>
	        	{ props.map === 't' && <Map { ...props } /> }
	        	{ props.gallery === 't' && <Gallery { ...props } /> }
	        	{ props.template === 'cruiseIntro' && <BookingCalendar start={ props.cruise.first_day } end={ props.cruise.last_day } /> }
            </div>
            <div className="half-text">
	            { props.children }
            </div>
		</div>
	</Center>
}
